import { useLocation } from "react-router-dom";
import DesktopNav from "./headerDesktop.component";
import MobileNav from "./headerMobile.component";

const Header = () => {
  const pathname = useLocation();

  return (
    <header className="bg-white w-full min-h-12 border-b-4 border-[#8B5C2A]">
      <div className="hidden lg:block">
        <DesktopNav pathname={pathname} />
      </div>
      <div className="lg:hidden">
        <MobileNav pathname={pathname} />
      </div>
    </header>
  );
};

export default Header;
